export default function Error() {
  return (
    <div className="bg-indigo-950 min-h-screen flex flex-col items-center justify-center">
      {/* Header */}
      <div>
        <img src={"./logo.png"} alt="Logo" className="w-40 h-40 rounded-xl" />
      </div>
      <div className="mb-8 mt-4">
        <h1 className="text-5xl text-blue-300">CozyIntros</h1>
      </div>

      <div>
        <p className="text-xl text-blue-100">
          There was an error. Please Try again.
        </p>
      </div>
    </div>
  );
}
